

export  async function getCountries(filterText, isOrder = false) {
  let url = "https://api.countrystatecity.in/v1/countries"
  let countries  = await getResults(url, filterText);
  if (isOrder) {
    if (CONFIG.ssoCountryWhitelist && Object.keys(CONFIG.ssoCountryWhitelist).length > 0) {
      const countryMap = new Map(countries.map(country => [country.iso2, country]));
      const result = [];
      for (let key in CONFIG.ssoCountryWhitelist) {
        const iso2 = CONFIG.ssoCountryWhitelist[key];
        if (countryMap.has(iso2)) {
          result.push(countryMap.get(iso2));
        }
      }
      return result;
    }
    const index1 = countries.findIndex(country => country.iso2 === CONFIG.ssoPrimaryCountryISO2);
    let orderedCountry = [];
    if (CONFIG.ssoSecondaryCountryISO2) {
      const index2 = countries.findIndex(country => country.iso2 === CONFIG.ssoSecondaryCountryISO2);
      const firstIndex = index1 > index2? index1 : index2;
      const secondIndex = index1 > index2? index2 : index1;
      orderedCountry = [].concat(countries[index1]).concat(countries[index2]).concat([].concat(countries.slice(0, firstIndex)).concat(countries.slice(firstIndex + 1, secondIndex)).concat(countries.slice(secondIndex + 1)))
    } else {
      orderedCountry = [].concat(countries[index1]).concat([].concat(countries.slice(0, index1)).concat(countries.slice(index1 + 1)))
    }
    return orderedCountry;
  }
  return countries;
}

export  function getStates(filterText = '', country) {
  let url = country ? `https://api.countrystatecity.in/v1/countries/${country}/states` : `https://api.countrystatecity.in/v1/states`;
  return  getResults(url, filterText);
}

export  function getCities(filterText = '', country = null, state = null) {
  if (!country) {
    country = CONFIG.ssoPrimaryCountryISO2;
  }
  console.log("getCities: ", state, country)
  // if (!country) {
  //   return ['please select country'];
  // }
  let url = state ? `https://api.countrystatecity.in/v1/countries/${country}/states/${state}/cities` : `https://api.countrystatecity.in/v1/countries/${country}/cities`;
  return  getResults(url, filterText);
}

function getResults(url, filterText) {
  var headers = new Headers();
  headers.append("X-CSCAPI-KEY", "QmhnbE9NR3Z1TGJZdzVEVVNUaGtSOTRzV0NKWXQ0UHpiMTQwVzdoTA==");
  var requestOptions = {
    method: 'GET',
    headers: headers,
    // redirect: 'follow'
  };

  return fetch(url, requestOptions)
    .then(response => {
      let result = response.json();
      return result;
    }).then(result => {
      console.log('filterText', filterText)
      if (filterText) {
        if (Array.isArray(filterText)) {
          result = result.filter(item => {
            if (!item.name) return false;
      	  return !filterText.includes(item.name);
          })
        } else {
              result = result.filter(item => {
                if (!item.name) return false;
                return !filterText.toLowerCase().includes(item.name.toLowerCase());
              })
        }
      }
      return result;
    })
}


export default {
  getCountries,
  getCities,
  getStates
};
